import type { RoofElevationPlanSettings, RoofPlanSettings } from "building-types/settings/roofPlanSettings";
import type { RoofSide } from "building-types/settings/roofTypes";
import type { Face } from "geom/brep";

export enum RoofFaceType {
  NORMAL = "NORMAL",
  TRUNCATED = "TRUNCATED",
  HIP = "HIP",
}

export interface RoofFaceProps {
  readonly type: RoofFaceType;
  readonly side: RoofSide;
  readonly isDormer: boolean;
  readonly annotationSettings: RoofPlanSettings & RoofElevationPlanSettings;
  readonly disableOverhangClipping: boolean;
}

export interface RoofFace extends RoofFaceProps {
  readonly face: Face;
}
